import { SVGProps } from "react";

export function UploadIcon({
  xmlns = "http://www.w3.org/2000/svg",
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    // <svg
    //   width={18}
    //   height={18}
    //   viewBox={"0 0 18 18"}
    //   fill="none"
    //   xmlns={xmlns}
    //   {...props}
    // >
    //   <g clipPath="url(#clip0_16330_91368)">
    //     <path
    //       d="M5.25009 13.4999C4.3143 13.4999 3.41683 13.1443 2.75513 12.5114C2.09342 11.8785 1.72168 11.02 1.72168 10.1249C1.72168 9.2298 2.09342 8.37135 2.75513 7.73842C3.41683 7.10548 4.3143 6.7499 5.25009 6.7499C5.4711 5.76529 6.11766 4.90001 7.04753 4.34444C7.50795 4.06934 8.02407 3.87856 8.56642 3.78299C9.10877 3.68741 9.66672 3.68891 10.2084 3.7874C10.7501 3.88589 11.265 4.07945 11.7236 4.35701C12.1821 4.63458 12.5755 4.99072 12.8812 5.4051C13.1868 5.81948 13.3988 6.28399 13.505 6.7721C13.6112 7.26021 13.6095 7.76237 13.5001 8.2499H14.2501C14.9463 8.2499 15.614 8.52646 16.1062 9.01875C16.5985 9.51103 16.8751 10.1787 16.8751 10.8749C16.8751 11.5711 16.5985 12.2388 16.1062 12.7311C15.614 13.2233 14.9463 13.4999 14.2501 13.4999H13.5001"
    //       stroke="#667085"
    //       strokeWidth="1.125"
    //       strokeLinecap="round"
    //       strokeLinejoin="round"
    //     />
    //     <path
    //       d="M6.75 11.25L9 9L11.25 11.25"
    //       stroke="#667085"
    //       strokeWidth="1.5"
    //       strokeLinecap="round"
    //       strokeLinejoin="round"
    //     />
    //     <path
    //       d="M9 9V15.75"
    //       stroke="#667085"
    //       strokeWidth="1.5"
    //       strokeLinecap="round"
    //       strokeLinejoin="round"
    //     />
    //   </g>
    //   <defs>
    //     <clipPath id="clip0_16330_91368">
    //       <rect width="18" height="18" fill="white" />
    //     </clipPath>
    //   </defs>
    // </svg>
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.37513 20.7496C6.97144 20.7496 5.62525 20.2162 4.63269 19.2668C3.64013 18.3174 3.08252 17.0298 3.08252 15.6871C3.08252 14.3445 3.64013 13.0568 4.63269 12.1074C5.62525 11.158 6.97144 10.6246 8.37513 10.6246C8.70665 9.14769 9.67649 7.84978 11.0713 7.01641C11.7619 6.60377 12.5361 6.3176 13.3496 6.17424C14.1631 6.03087 15.0001 6.03312 15.8126 6.18086C16.6252 6.3286 17.3975 6.61893 18.0853 7.03527C18.7732 7.45162 19.3633 7.98583 19.8217 8.6074C20.2802 9.22898 20.5982 9.92574 20.7575 10.6579C20.9168 11.3901 20.9143 12.1433 20.7501 12.8746H21.8751C22.9194 12.8746 23.9209 13.2895 24.6594 14.0279C25.3978 14.7663 25.8126 15.7678 25.8126 16.8121C25.8126 17.8564 25.3978 18.8579 24.6594 19.5963C23.9209 20.3348 22.9194 20.7496 21.8751 20.7496H20.7501" stroke="#008934" stroke-width="1.6875" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M10.625 17.375L14 14L17.375 17.375" stroke="#008934" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M14 14V24.125" stroke="#008934" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
  );
}
